import React from 'react';
import { observer } from 'mobx-react-lite';
import styled from '@emotion/styled';

import { getColor } from '../common/UICommon';

import { StepWrapperBox } from '../styledComponent/Boxes.style';

import gift from '../../assets/gift.svg';
import star from '../../assets/star.svg';

import { BaseStep, StepProps, StepWizardProps, TitleAndDescriptionProps } from '../common/BaseStep';

const SpecialOfferBanner = styled.div`
  background: linear-gradient(91.86deg, #6b65e7 0%, #9e65e7 100%);
  border-radius: 12px;
  color: ${getColor('WHITE')};
  font-size: 14px;
  line-height: 20px;
  padding: 19px 19px 24px 24px;
  font-weight: 500;
  font-family: 'Poppins';
  margin-bottom: 24px;
`;

const Flex = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

const TextSection = styled.div`
  padding-right: 5px;
`;

const Gift = styled.img`
  margin-top: 13px;
  margin-bottom: 16px;
`;

const Bold = styled.p`
  font-weight: 600;
`;

const TextInformation = styled.p`
  font-size: 16px;
  line-height: 24px;
  color: ${getColor('BLACK_80')};
  &.purple {
    color: ${getColor('PURPLE_100')};
    font-weight: 600;
  }
`;

interface SpecialOfferProps extends TitleAndDescriptionProps, StepProps, StepWizardProps {
  specialOfferBanner: {
    text: string;
    boldText: string[];
  };
  textInformation: string[];
  promoCode: string;
}

export const SpecialOfferStep = observer((props: SpecialOfferProps) => {
  const { specialOfferBanner, textInformation, promoCode, isActive } = props;

  return (
    <>
      {isActive ? (
        <BaseStep {...props}>
          <StepWrapperBox>
            <SpecialOfferBanner>
              <Flex>
                <Gift src={gift} alt="gift" />
                <img src={star} alt="star" />
              </Flex>
              <TextSection>
                {specialOfferBanner.text ? <p>{specialOfferBanner.text}</p> : null}
                {specialOfferBanner.boldText && specialOfferBanner.boldText.length > 0
                  ? specialOfferBanner.boldText.map((boldText) => <Bold key={boldText}>{boldText}</Bold>)
                  : null}
              </TextSection>
            </SpecialOfferBanner>

            {textInformation && textInformation.length > 0
              ? textInformation.map((text) => <TextInformation key={text}>{text}</TextInformation>)
              : null}
            {promoCode ? <TextInformation className="purple">{promoCode}</TextInformation> : null}
          </StepWrapperBox>
        </BaseStep>
      ) : (
        ''
      )}
    </>
  );
});
